import { render, staticRenderFns } from "./SettingsGradient.vue?vue&type=template&id=5cb7f0c9"
import script from "./SettingsGradient.vue?vue&type=script&lang=js"
export * from "./SettingsGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports